import { Avatar } from "@shared/ui.components"
import { colours } from "@shared/ui.design-system";
import { CloseIcon } from "@shared/ui.icons";
import { Button, Drawer, Typography } from "@shared/ui.primitives";
import { cloudinaryLoader } from "@shared/utils.cloudinary";
import Image from "next/image";

import { Nav } from "./Nav";
import * as styles from "./ProfileFlyout.css";

const backgroundImage = "https://res.cloudinary.com/beautypie/image/upload/v1763399861/profile-flyout-bg_dcggfi.jpg"

type Props = {
  isOpen: boolean;
  handleDismiss: () => void;
  handleSignout: () => void;
  isMember: boolean;
  email: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  image?: string;
};

export const ProfileFlyout: React.FC<Props> = ({
  isOpen,
  handleDismiss,
  handleSignout,
  isMember,
  email,
  firstName,
  lastName,
  image = backgroundImage
}) => {

  return (
    <Drawer
      id="profile_flyout"
      headerId="profile_flyout_header"
      isOpen={isOpen}
      anchorPosition="right"
    >
      <Drawer.Header id="profile_flyout_header" noPadding>
        <div className={styles.headerContainer}>
          <button
            onClick={() => handleDismiss()}
            aria-label="Close Navigation Menu"
            className={styles.closeButton}>
            <CloseIcon color={colours.secondary.light} className={styles.closeIcon} />
          </button>

          <div className={styles.headerBackground}>
            <Image
              src={image}
              alt="Background"
              width={300}
              height={100}
              sizes="100%"
              style={{width: '100%',height: 'auto'}}
              loader={cloudinaryLoader}
            />
            
            <Avatar firstName={firstName} lastName={lastName} size="lg" className={styles.headerAvatar}/>
          </div>
        </div>
      </Drawer.Header>

      <Drawer.Body className={styles.bodyContainer}>
        <div className={styles.profileInfo}>
              <Typography variant="subheader-4" colour="primary-dark" as="span">Hello {firstName}</Typography>
              <Typography variant="body-md" colour="primary-medium" as="span">{email}</Typography>
        </div>

        <Nav isMember={isMember} className={styles.nav}/>

        <Button
          aria-label="Sign out"
          variant="link"
          text="Sign out"
          noPadding
          onClick={handleSignout}
        />
      </Drawer.Body>

    </Drawer>
  );
};
